<div>
    <div class="property_name">{{propertyData.propNme}}</div>

    <div class="compliance_button">
        <button class="button_compliant no_click" fmButton
            *ngIf="propertyData.complianceRate == 'Compliant'">{{propertyData.complianceRate}}</button>
        <button class="button_non_compliant no_click" fmButton
            *ngIf="propertyData.complianceRate == 'Non-Compliant'">{{propertyData.complianceRate}}</button>
        <button class="button_pending no_click" style="color:#000000" fmButton
            *ngIf="propertyData.complianceRate == 'Pending'">{{propertyData.complianceRate}}</button>
    </div>

    <fm-dataList>

        <ng-template fmTemplate="subheader">
            <div class="my_datalist_container">
                <div class="my_datalist_label">COLLATERAL REFERENCE #</div>
                <div class="my_datalist_text">{{propertyData.coltRefNo}}</div>
            </div>

            <div class="my_datalist_container">
                <div class="my_datalist_label">DEAL NAME</div>
                <div class="my_datalist_text">{{propertyData.dlNme}}</div>
            </div>

            <div class="my_datalist_container">
                <div class="my_datalist_label">DUS GATEWAY DEAL ID</div>
                <div class="my_datalist_text">{{propertyData.dusDealId}}</div>
            </div>
            
            <div class="my_datalist_container">
                <div class="my_datalist_label">ACQUISITION DEAL ID</div>
                <div class="my_datalist_text">{{propertyData.aqsnDealId}}</div>
            </div>

            <div class="my_datalist_container">
                <div class="my_datalist_label">(EST.) ACQUISITION DATE</div>
                <div class="my_datalist_text">{{propertyData.aqsnDt}}</div>
            </div>

            <div class="my_datalist_container">
                <div class="my_datalist_label">REQUIRED SUBMISSION DATE</div>
                <div class="my_datalist_text">{{propertyData.reqdSubmDt}}</div>
            </div>

            <div class="my_datalist_container">
                <div class="my_datalist_label">LAST SUBMITTED DATE</div>
                <div class="my_datalist_text">{{propertyData.maxSubmtDt}}</div>
            </div>

        </ng-template>


    </fm-dataList>

    <div class="sub_header">Upload Documentation</div>

    <fm-table [columns]="cols" [value]="data" sortMode="single">
        <ng-template fmTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns" [fmSortableColumn]="col.field">{{col.header}}
                    <fm-sortIcon [field]="col.field"></fm-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template fmTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td *ngFor="let col of columns" [style.width]="col.width">
                    <p *ngIf="col.field != 'docType'" style="text-align: center;">{{rowData[col.field]}}</p>

                    <p *ngIf="col.field == 'docType' && (rowData[col.field]).includes('_Y_')" style="text-align: center;">
                        <button class="button_indicator button_y">{{rowData[col.field].substring(0, rowData[col.field].indexOf("_"))}}</button>
                    </p>

                    <p *ngIf="col.field == 'docType' && ((rowData[col.field]).includes('_N_') || (rowData[col.field]).includes('_null_'))" style="text-align: center;">
                        <button class="button_indicator button_n">Missing {{rowData[col.field].substring(0, rowData[col.field].indexOf("_"))}}</button>
                    </p>

                    <p *ngIf="col.field == 'docType' && (rowData[col.field]).includes('_N/A_')" style="text-align: center;">
                        <button class="button_indicator button_na">{{rowData[col.field].substring(0, rowData[col.field].indexOf("_"))}}</button>
                    </p>
                </td>
            </tr>
        </ng-template>
      </fm-table>    

    <br>
    <button *ngIf="disableUpload == true" disabled class="center-button-top" fmButton type="button" [large]="true" label="Upload Files" icon="fmi fmi-upload"
        (click)="showUploadFilesDialog(true)"></button>
    <button  *ngIf="disableUpload == false" class="center-button-top" fmButton type="button" [large]="true" label="Upload Files" icon="fmi fmi-upload"
        (click)="showUploadFilesDialog(true)"></button>

    <button class="center-button" fmButton [primary]="true" type="button" [large]="true" label="Close"
        (click)="onClickCloseSidebar()"></button>
</div>